import { useTranslation } from '@eti/providers';
import { useGetBlue, eventTypes } from '../../../utils/useGetBlue';
import SubPage from './SubPage';

const AboutUsPage = () => {
  const { t } = useTranslation();

  useGetBlue(eventTypes.VISIT);

  return (
    <SubPage
      image="content/cookies"
      pageTitle={t('PageTitle.rf.about-us.action')}
      textKey="AboutUs.HtmlContent"
    />
  );
};

export default AboutUsPage;
